<template lang="html">
  <div
    ref="index"
    class="clearing"
    v-observe-visibility="{
      callback: visibilityChanged,
      intersection: {
        rootMargin: '200px',
      },
    }"
  >
    <!-- <div
      v-if="enabled('campaigns')"
      class="ui progress small"
      :class="{ red: percentDeliverablesQuotaUsed > 89 }"
      :data-percent="percentDeliverablesQuotaUsed"
    >
      <div class="bar">
        <div class="progress" />
      </div>
      <div class="label">
        {{ percentDeliverablesQuotaUsed }}% of deliverable quota used
      </div>
    </div> -->

    <div>
      <div class="ui mini top attached compact tabular menu">
        <a href="#" class="active item" data-tab="multiple">
          <i class="icon list" />
          Links
        </a>
        <a href="#" class="item" data-tab="search" v-if="igStoriesEnabled">
          <i class="icon instagram" />
          Stories
          {{ `(${igStoriesDeliverables.length})` }}
        </a>

        <a
          href="#"
          class="item"
          data-tab="search-pinterest"
          v-if="quickSearchEnabled"
        >
          <i class="icon search" />
          Quick Search
        </a>

        <a
          href="#"
          data-tab="saved_search"
          class="item"
          v-if="enabled('saved_search')"
        >
          <i class="icon search plus"></i>
          Saved Search
        </a>

        <a v-show="showTemplate" href="#" class="item" data-tab="template">
          <i class="icon magic" />
          Use template
        </a>

        <!-- <a class="right item" v-show="erroredDeliverables.length > 0">
          <troubleshooter :only-errored="true" />
        </a> -->
      </div>

      <div class="ui bottom attached active tab segment" data-tab="multiple">
        <multiple-deliverable-form
          ref="formMultiple"
          :endpoint="endpoint"
          @create="addMultipleDeliverables"
          @requestQuickSearch="showQuickSearchForProvider"
          @requestStoriesSearch="showStoriesSearch"
        />
      </div>

      <div
        v-if="!igStoriesEnabled"
        class="ui bottom attached tab padded segment"
        data-tab="search"
      >
        <div class="ui placeholder segment">
          <div class="ui header">
            Your plan doesn't include access to this feature.
          </div>
          <p>
            Please
            <a href="/billing">click here to upgrade</a>
          </p>
        </div>
      </div>
      <div
        v-else
        class="ui bottom attached tab padded segment"
        data-tab="search"
      >
        <h2 class="ui header fluid">
          Stories
          <div class="sub header">
            Add Instagram Stories to your report
            <small v-if="shouldShowSearchForm">
              <em>(drag or click to select)</em>
            </small>
            <small v-else class="right floated">
              <i
                v-if="igStoriesDeliverables.length > 0"
                class="icon th link"
                :class="{ pink: cardGridCount === 8 }"
                @click.stop="toggleGridCount"
              />
              <i
                v-if="igStoriesDeliverables.length > 0"
                class="icon th large link"
                :class="{ pink: cardGridCount === 4 }"
                @click.stop="toggleGridCount"
              />
            </small>
          </div>
        </h2>
        <div
          class="ui message info"
          v-if="!shouldShowSearchForm && sortedInstagramStories.length > 0"
        >
          <i class="icon info circle"></i>
          Link clicks (swipe ups), and sticker taps must be added manually.
          <a
            href="https://help.influencekit.com/en/articles/4278599-how-do-i-add-swipe-ups-and-click-stats-to-my-instagram-stories"
            target="_blank"
            >Here's how.</a
          >
        </div>

        <deliverable-search-form
          v-if="shouldShowSearchForm"
          ref="searchForm"
          class="searchForm"
          :event="event"
          :endpoint="endpoint"
          provider="instagram_stories"
          :initial-selected-deliverables="igStoriesDeliverables"
          @save="addDeliverable"
          @hide="hideSearchForm"
        />

        <div
          v-show="!shouldShowSearchForm"
          class="deliverables ui cards doubling clearboth"
          :class="cardGridClassObject"
        >
          <div class="ui card addStory link" @click="showSearchForm">
            <div class="ui embed 9:16">
              <div>
                <i class="icon plus circle big inverted" />
                <p>Add Story</p>
              </div>
            </div>
          </div>

          <instagram-story
            v-if="isVisible"
            v-for="deliverable in sortedInstagramStories"
            :key="deliverable.id"
            :selectable="false"
            :deletable="true"
            :editable="true"
            :endpoint="endpoint"
            :metric-types="metricTypes"
            :deliverable="deliverable"
            @delete="deleteDeliverable"
          />
        </div>
      </div>

      <div
        class="ui bottom attached tab padded segment"
        data-tab="search-pinterest"
      >
        <h2 class="ui header fluid">
          Find Deliverables
          <div class="sub header">Add deliverables to your report</div>
        </h2>

        <deliverable-search-form
          ref="quickSearchForm"
          class="searchForm"
          :event="event"
          :endpoint="endpoint"
          :initial-selected-deliverables="deliverables"
          @saveMultiple="saveMultiple"
        />
      </div>

      <div
        data-tab="saved_search"
        class="ui bottom attached padded tab segment"
      >
        <turbo-frame
          :id="`saved_search_event_${event.id}`"
          :src="`/events/${event.id}/saved_search`"
          loading="lazy"
        ></turbo-frame>
      </div>

      <div
        v-show="showTemplate"
        class="ui bottom attached tab segment"
        data-tab="template"
      >
        <strong>Load these deliverables?</strong>

        <ul class="ui sixteen wide list">
          <li v-for="deliverable in suggestedDeliverables">
            {{ deliverable.name }}
          </li>
        </ul>
        <a
          class="ui button"
          @click.stop.prevent="addSuggestedDeliverables(suggestedDeliverables)"
        >
          Yes!
        </a>
      </div>
    </div>

    <div class="ui clearing">
      <!--
        campaigns#show inlines only the first page (see
        CampaignsController::INLINE_DELIVERABLES_PAGE_SIZE) and the rest stream
        in below. Say so out loud: the tab counts, the quick-search
        already-added marks and the filter all read off `deliverables`, so a
        silent partial load would quietly report the wrong numbers.
      -->
      <div v-if="isLoadingRemainder" class="deliverables-loading">
        <div class="ui active inline mini loader" />
        Loading deliverables… {{ deliverables.length }} of
        {{ deliverablesTotal }}
      </div>
      <div
        v-else-if="remainderFailed"
        class="deliverables-loading deliverables-loading--error"
      >
        <i class="icon exclamation triangle" />
        Only {{ deliverables.length }} of {{ deliverablesTotal }} deliverables
        loaded.
        <a href="#" @click.prevent="loadRemainingDeliverables">Try again</a>
      </div>

      <div v-if="urlDeliverables.length > 10" class="ui secondary right menu">
        <div class="ui right aligned item fitted">
          <div class="ui left icon input">
            <i class="search link icon" />
            <input
              v-model="searchString"
              class="prompt"
              type="text"
              placeholder="Find deliverables"
            />
          </div>
        </div>
      </div>

      <deliverable-form
        v-for="(deliverable, index) in urlDeliverables"
        v-show="deliverableIsVisible(deliverable)"
        :key="deliverable.id || index"
        :initial-deliverable="deliverable"
        :metric-types="metricTypes"
        :endpoint="endpoint"
        class="ui segment margin-bottom-medium"
        @delete="deleteDeliverable"
      />
    </div>
    <a
      href="https://help.influencekit.com/en/articles/3030998-how-do-i-add-deliverables-to-a-campaign-or-assignment"
      target="_blank"
    >
      <i class="ui icon question mark circle"></i>
      Learn more about how to add deliverables.
    </a>
    <br /><br />
    <button
      v-if="deliverables.length > 0"
      class="ui button right floated save-deliverables"
      :class="{
        loading: saveState === 'saving',
        disabled: saveState === 'saving',
        positive: saveState === 'saved',
      }"
      @click.stop.prevent="saveAll"
    >
      <i v-if="saveState === 'saved'" class="check icon"></i>
      {{ saveState === "saved" ? "Saved" : "Save Deliverables" }}
    </button>
  </div>
</template>

<script>
import Vue from "vue";
import VueObserveVisibility from "vue-observe-visibility";
import { mapState, mapGetters } from "vuex";
import store from "store";
import EventBus from "components/eventbus";
import DeliverableForm from "views/deliverables/form.vue";
import DeliverableSearchForm from "views/deliverables/search.vue";
import MultipleDeliverableForm from "views/deliverables/formMultiple.vue";
import InstagramStory from "./components/instagramStory.vue";
import Troubleshooter from "./troubleshooter.vue";
import _ from "lodash";
Vue.use(VueObserveVisibility);

const $ = window.jQuery;

export default {
  store,
  components: {
    DeliverableForm,
    MultipleDeliverableForm,
    DeliverableSearchForm,
    EventBus,
    InstagramStory,
    Troubleshooter,
  },
  props: {
    lazyLoad: {
      type: Boolean,
      default: true,
    },
    igStoriesEnabled: Boolean,
    endpoint: String,
    initialDeliverables: Array,
    // The event's REAL deliverable count, when the server inlined only the
    // first page. Null everywhere else (assignments, tenant_assignments), and
    // null means "what you were handed is all there is" — so every other call
    // site behaves exactly as before.
    deliverablesTotal: {
      type: Number,
      default: null,
    },
    deliverablesPerPage: {
      type: Number,
      default: 100,
    },
    initialEvent: Object,
    metricTypes: Array,
    suggestedDeliverables: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    const $this = this;
    return {
      isVisible: $this.lazyLoad ? false : true,
      searchString: "",
      shouldShowSearchForm: false,
      showMultipleForm: false,
      showSuggested: false,
      // deliverables: $this.initialDeliverables,
      newDeliverable: {
        manual_update_statistics: [],
      },
      cardGridCount: 8,
      // idle | saving | saved — drives the "Save Deliverables" button feedback
      saveState: "idle",
      // idle | loading | failed — the lazy load of deliverables past page 1
      remainderState: "idle",
    };
  },
  computed: {
    deliverables: {
      get() {
        return this.$store.state.deliverable.all;
      },
      set(val) {
        this.$store.dispatch("deliverable/setAll", {
          items: val,
        });
      },
    },
    igStoriesDeliverables() {
      return _.filter(
        this.deliverables,
        (d) => d.inferred_type === "instagram_stories"
      );
    },
    sortedInstagramStories() {
      return _.sortBy(this.igStoriesDeliverables, (d) =>
        window.moment(d.provider_published_at)
      );
    },
    urlDeliverables() {
      return _.orderBy(
        _.filter(
          this.deliverables,
          (d) => d.inferred_type !== "instagram_stories"
        ),
        ["created_at"],
        ["desc"]
      );
    },
    erroredDeliverables() {
      return this.urlDeliverables.filter((d) => !d.last_fetched);
    },
    ...mapState("event", {
      event: "current",
      currentDeliverables: "currentDeliverables",
    }),
    ...mapGetters("app", ["enabled"]),
    percentDeliverablesQuotaUsed() {
      return this.$store.state.app.config.percentage_deliverables_quota_used;
    },
    // Quick Search is deliberately NOT plan-gated: it's how creators build
    // reports, and shared reports are our widest acquisition surface. The one
    // case it stays hidden is a brand-owned "added influencer" row, where the
    // deliverables index belongs to the brand and searching *their* connected
    // accounts from an influencer's assignment would be wrong. That's exactly
    // what the ig-stories flag already encodes at every call site
    // (`!added_influencer? && tenant.enabled?('ig_stories')`), so reuse it
    // rather than threading a second, identical boolean through four HAML
    // templates.
    quickSearchEnabled() {
      return this.igStoriesEnabled;
    },
    showTemplate() {
      return (
        this.deliverables.length < 1 && this.suggestedDeliverables.length > 0
      );
    },
    isLoadingRemainder() {
      return this.remainderState === "loading";
    },
    remainderFailed() {
      return this.remainderState === "failed";
    },
    cardGridClassObject() {
      return {
        eight: this.cardGridCount === 8,
        four: this.cardGridCount === 4,
      };
    },
  },

  watch: {
    currentDeliverables(val) {
      this.deliverables = val;
    },
  },
  mounted() {
    if (this.initialDeliverables) this.deliverables = this.initialDeliverables;
    // Publish the true total before anything renders a count off it. Call
    // sites that inline everything pass no total and this stores null, which
    // is what `deliverable/count` already treated as "all.length".
    this.$store.dispatch("deliverable/setTotal", {
      value:
        this.deliverablesTotal === undefined ? null : this.deliverablesTotal,
    });
    this.loadRemainingDeliverables();

    if (this.initialEvent) {
      this.$store.dispatch("event/setCurrent", { item: this.initialEvent });
    }
    $(this.$el)
      .find(".tabular.menu .item")
      .tab({ onVisible: this.tabBecameVisible });
  },
  methods: {
    // Pull in every deliverable past the first inlined page, one page at a
    // time, from the JSON index the component already points at. Sequential on
    // purpose: production runs ten request slots and a 2,000-deliverable report
    // is twenty pages — firing them in parallel would trade one slow page for
    // twenty simultaneous ones, which is the failure this whole change exists
    // to stop.
    async loadRemainingDeliverables() {
      if (!this.deliverablesTotal) return;
      if (this.deliverables.length >= this.deliverablesTotal) return;

      const per = this.deliverablesPerPage || 100;
      const lastPage = Math.ceil(this.deliverablesTotal / per);
      this.remainderState = "loading";

      try {
        for (let page = 2; page <= lastPage; page++) {
          const rows = await $.getJSON(`${this.endpoint}.json`, { page, per });
          if (!rows || rows.length === 0) break;
          this.appendDeliverables(rows);
        }
        // Running out of pages early is a failure, not a finish. A broken
        // endpoint answers `[]` rather than raising, so the loop above would
        // break out, the banner would disappear and the list would sit at one
        // page looking complete next to a tab badge reading the true total.
        // Partial is fine; silently partial is not.
        this.remainderState =
          this.deliverables.length >= this.deliverablesTotal
            ? "idle"
            : "failed";
      } catch (e) {
        // Same contract for a request that actually threw.
        this.remainderState = "failed";
      }
    },
    // Merge by id. The server orders by (provider_published_at DESC, id DESC)
    // and campaigns#show inlines page 1 of that same ordering, so pages should
    // not overlap — but a deliverable created between the page render and the
    // fetch would shift the window, and showing it twice is worse than the
    // cost of this check.
    appendDeliverables(rows) {
      const seen = new Set(this.deliverables.map((d) => d.id));
      const fresh = rows.filter((d) => !seen.has(d.id));
      if (fresh.length > 0) this.deliverables = this.deliverables.concat(fresh);
    },
    tabBecameVisible(tabPath) {
      if (tabPath !== "search-pinterest") return;

      // Opening Quick Search asks the server for a fresh index. Fire and
      // forget — the tab has already rendered its cached results, and the
      // endpoint throttles itself, so re-opening the tab costs nothing.
      const form = this.$refs.quickSearchForm;
      if (form) form.refreshDeliverables();
    },
    visibilityChanged(value) {
      this.isVisible = this.isVisible || value;
    },
    toggleGridCount(e) {
      if (this.cardGridCount === 8) {
        this.cardGridCount = 4;
      } else {
        this.cardGridCount = 8;
      }
      e.stopPropagation();
      return false;
    },
    deliverableIsVisible(del) {
      return [del.name, del.url, del.inferred_type]
        .join()
        .match(new RegExp(this.searchString, "i"));
    },
    hideSearchForm() {
      this.shouldShowSearchForm = false;
    },
    showSearchForm() {
      this.shouldShowSearchForm = true;
    },
    changeTab(tab) {
      $(this.$el).find(".tabular.menu .item").tab("change tab", tab);
    },
    showQuickSearchForProvider(provider) {
      // Move to the Quick Search tab and filter it to a single provider by
      // assigning selectedProviders directly. Assigning (not toggling) means a
      // repeat hand-off always lands on exactly the requested provider,
      // regardless of what was checked before.
      this.changeTab("search-pinterest");
      this.$nextTick(() => {
        const form = this.$refs.quickSearchForm;
        if (form) {
          form.selectedProviders = [provider];
        }
      });
    },
    showStoriesSearch() {
      // Move to the Stories tab and open its search form via state.
      this.changeTab("search");
      this.showSearchForm();
    },
    addMultipleDeliverables(deliverables) {
      this.addDeliverables(deliverables);
    },
    addSuggestedDeliverables(deliverables) {
      this.addDeliverables(deliverables);
      this.saveAll();
    },
    addDeliverables(deliverables) {
      deliverables.forEach((deliverable) => {
        this.addDeliverable(JSON.parse(JSON.stringify(deliverable)));
      });
    },
    addDeliverable(deliverable) {
      this.deliverables.unshift(deliverable);
      this.adjustTotal(1);
      this.$emit("addDeliverable", deliverable);
      // EventBus.$emit("deliverableCreated", deliverable);
    },
    // The lazy load does NOT touch the total (those rows were always counted);
    // adding and deleting do, so a paginated page's badge stays correct
    // without waiting for the stream to finish.
    adjustTotal(delta) {
      const total = this.$store.state.deliverable.total;
      if (total === null || total === undefined) return;
      this.$store.dispatch("deliverable/setTotal", { value: total + delta });
    },
    saveMultiple(urls) {
      // oh this is bad here
      this.$refs.formMultiple.urls = urls;
      this.$refs.formMultiple.addUrls();
    },
    saveAll() {
      // Guard against rage-clicks: ignore re-entry while a save is in flight.
      if (this.saveState === "saving") return;
      this.saveState = "saving";

      EventBus.$emit("saveAllDeliverables");

      // Each deliverable form persists via its own AJAX request (and shows its
      // own "Saved" toast). Give the bulk button immediate feedback so users
      // know the click registered, then confirm with a brief "Saved" state.
      setTimeout(() => {
        this.saveState = "saved";
        setTimeout(() => {
          if (this.saveState === "saved") this.saveState = "idle";
        }, 2000);
      }, 600);
    },
    deleteDeliverable(deliverable) {
      const before = this.deliverables.length;
      this.deliverables = this.deliverables.filter(
        (x) => x.id !== deliverable.id
      );
      if (this.deliverables.length < before) this.adjustTotal(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 400px) {
  .tabular.menu {
    .item {
      i {
        display: none;
      }
      // border: none !important;

      // &:before {
      //   display: initial !important;
      // }
    }
  }
}

.deliverables-loading {
  color: var(--text-muted);
  font-size: 0.9em;
  padding: 0.5rem 0;

  .loader {
    margin-right: 0.5rem;
  }

  &--error {
    color: var(--text-secondary, var(--text-muted));
  }
}

.card.addStory {
  box-shadow: none !important;
  background: radial-gradient(
      circle at center,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.65)
    ),
    url("./images/ig_story_placeholder.jpg") center/cover no-repeat !important;

  .ui.embed > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    color: #fff;
    p {
      margin-top: 1em;
    }
  }
}

div.ui[class*="9:16"].embed {
  padding-bottom: 178%;
  background: none !important;
}

.sub.header small {
  color: var(--text-muted);
}

i.th,
i.sync {
  font-size: 1.5em !important;
  vertical-align: baseline !important;
}

// "Save Deliverables" is a plain gray `.ui.button` while the modal's own
// "Add" (formMultiple.vue) is `.ui.button.primary` — the wave's own
// hierarchy rule (primary CTA = solid brand color), unapplied to this
// terminal action. Native-scoped: web keeps its current gray button.
// :not(.positive) leaves the post-save green "Saved" confirmation alone.
html[data-hotwire-native] .save-deliverables:not(.positive) {
  background: var(--color-primary, #f4806f) !important;
  color: #fff !important;

  &:hover,
  &:focus,
  &:active {
    background: var(--color-primary-hover, #e06b5a) !important;
    color: #fff !important;
  }
}
</style>
